<svg
    xmlns="http://www.w3.org/2000/svg"
    width="1921.831"
    height="195.255"
    viewBox="0 0 1921.831 195.255"
    preserveAspectRatio="none"
>
    <path
        id="Pfad_26"
        data-name="Pfad 26"
        d="M-2086.529,1072.574s156.415-120,533.84-111.352,740.033,46.188,897.082,40.635,354.3-56.187,490.909-107.7v195.086l-1921.831.169Z"
        transform="translate(2086.529 -894.155)"
        fill="#373b41"
    />
</svg>
